<template>
  <div class="uk-card uk-card-default uk-padding">
    <div class="uk-grid uk-child-width-1-2">
      <div>
        <template v-if="!showTimer">
          <div class="uk-text-center">
            <template v-if="downtime.on_shift || downtime.count_personal_orders > 0">
              <template v-if="downtime.user_can_take_order">
                <div class="tm-title-get-order uk-flex-center">
                  {{ local_page_keys.label_you_can_take_a_new_order }}
                </div>
                <div class="uk-width-large uk-margin-auto uk-margin-top">
                  <button type="button" class="uk-button uk-button-success tm-light" @click="getNewOrder()" :disabled="loading">
                    {{ local_page_keys.button_get_a_new_order }}
                    <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="tm-title-get-order uk-flex-center">
                  {{ local_page_keys.title_no_available_orders }}
                </div>
                <div class="uk-width-large uk-margin-auto uk-margin-top">
                  <div>
                    <button disabled class="tm-button-grey uk-button">
                      {{ local_page_keys.button_no_orders_in_the_queue }}
                    </button>
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="pos: bottom-center; offset: 15">
                    {{local_page_keys.button_no_orders_in_the_queue_popup}}
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="tm-title-get-order  uk-flex-center">
                {{local_page_keys.message_cant_take_the_order}}
              </div>
              <div class="uk-width-large uk-margin-auto uk-margin-top">
                <div>
                  <button disabled class="uk-button tm-button-pink tm-button-get-order" style="cursor: inherit">
                    {{ local_page_keys.message_not_registered_for_this_shift }}
                  </button>
                </div>
                <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="pos: bottom-center; offset: 15">
                  {{local_page_keys.message_not_registered_for_this_shift_popup}}
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="uk-text-center">
            <div class="uk-grid uk-flex-center uk-text-center" data-uk-grid>
              <template v-if="downtime.user_can_take_order">
                <div class="uk-width-large uk-margin-auto">
                  <button type="button" class="uk-button uk-button-success tm-light uk-margin-top" @click="getNewOrder()" :disabled="loading">
                    {{ local_page_keys.button_get_a_new_order }}
                    <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="uk-width-large uk-margin-auto uk-margin-top">
                  <button disabled class="tm-button-grey uk-button">
                    {{ local_page_keys.button_no_orders_in_the_queue }}
                  </button>
                </div>
              </template>
            </div>
          </div>
        </template>

        <div class="uk-margin-auto uk-margin-top">
          <CountNewOrdersFuncBased :role="role"
                                   :local_page_keys="local_page_keys"
                                   ref="childRefNewOrders"
                                   :downtime="downtime"/>
        </div>
      </div>
      <!-- prostoy part -->
      <div>
        <template>
          <div class="uk-text-center">
            <template v-if="[1,2].indexOf(downtime.user_idle_time_button_type) > -1 && downtime.temporary_cash_orders_no_with_logreq23">

              <template v-if="downtime.user_idle_time_check">
                <div class="tm-title-get-order uk-flex-center">
                  {{ local_page_keys.idle_time_started }}
                </div>
                <div class="uk-width-large uk-margin-auto uk-margin-top">
                  <button type="button" class="tm-button-blue uk-button" :data-batton-type="downtime.user_idle_time_button_type" disabled>
                    {{formattedTime}}
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="tm-title-get-order uk-flex-center">
                  {{ local_page_keys.idle_time_enabled }}
                </div>
                <div class="uk-width-large uk-margin-auto uk-margin-top">
                  <button type="button" class="uk-button tm-button-blue tm-light" :data-batton-type="downtime.user_idle_time_button_type" @click.prevent.stop="setToIdleTime()" :disabled="idleLoading">
                    {{ local_page_keys.idle_time_start }}
                    <span v-if="idleLoading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
                  </button>
                </div>
              </template>
            </template>
            <template v-else-if="[0,3].indexOf(downtime.user_idle_time_button_type) > -1">
              <div class="tm-title-get-order uk-flex-center">
                {{ local_page_keys.idle_time_disabled }}
              </div>
              <div class="uk-width-large uk-margin-auto uk-margin-top">
                <div>
                  <button type="button" class="tm-button-grey uk-button 1" :data-batton-type="downtime.user_idle_time_button_type" disabled>
                    {{ local_page_keys.idle_time_start }}
                  </button>
                </div>
                <div
                    style="width:360px;"
                    class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                    data-uk-dropdown="pos: bottom-center; offset: 15">
                  {{local_page_keys.idle_time_start_disabled_tooltip}}
                </div>
              </div>
            </template>
            <template v-else>
              <div class="tm-title-get-order uk-flex-center">
                {{ local_page_keys.idle_time_disabled }}
              </div>
              <div class="uk-width-large uk-margin-auto uk-margin-top">
                <div>
                  <button type="button" class="tm-button-grey uk-button" disabled>
                    {{ local_page_keys.idle_time_start }}
                    <template v-if="secondsCounterTemporaryCashOrdersTtlTime >  0">
                      ({{secondsCounterTemporaryCashOrdersTtlTime}})
                    </template>
                  </button>
                </div>
                <div v-if="secondsCounterTemporaryCashOrdersTtlTime > 0" class="uk-dropdown tm-dropdown tm-dropdown-bottom-center" data-uk-dropdown="pos: bottom-center; offset: 15">
                  {{local_page_keys.idle_time_disabled_tooltip}} - {{secondsCounterTemporaryCashOrdersTtlTime}} {{local_page_keys.idle_time_seconds}}
                  <br>
                  {{local_page_keys.idle_time_start_disabled_tooltip_part2}}
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
    <!-- prostoy part -->
  </div>
</template>

<script>

import CountNewOrdersFuncBased from "@/pages/Dashboard/Components/CountNewOrdersFuncBased";
import downtime from "../Downtime.vue";

export default {
  name: "RetouchersInactivityTimerFuncBased",
  components: {CountNewOrdersFuncBased},
  props: {
    downtime: {},
    user:{
      type: Object,
    }
  },
  data: () => ({
    orderdays: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    showTimer: false,
    interval: null,
    interval2: null,
    orderDateTime: null,
    local_page_keys: {},
    orderCurrDate: null,
    role: '',
    //countdown: 120,
    intervalTtlId: null,
    loading:false,
    idleLoading:false,
    retryCounter: 0,
    secondsCounter: 0,
    secondsCounterTemporaryCashOrdersTtlTime: 0,
    timer: null
  }),
  methods: {
    diffOrderMinutes(data) {
      let orderDate = this.orderDateTime !== null ? this.orderDateTime : Date.now();
      this.showTimer = (orderDate === this.orderDateTime ? true : false);
      let diff = this.orderCurrDate - orderDate;
      if (data === 'minutes') {
        return Math.floor((diff % 3.6e6) / 6e4);
      } else if (data === 'hours') {
        let hours = Math.floor(diff / 3.6e6);
        if (hours > 24) {
          let days = Math.floor(hours / 24);
          hours = hours - 24 * days;
        }
        return hours;
      } else if (data === 'seconds') {
        return Math.floor((diff % 60000) / 1000);
      } else if (data === 'days') {
        let hours = Math.floor(diff / 3.6e6);
        return Math.floor(hours / 24);
      }
    },
    async setToIdleTime() {
      let params = { role:'retoucher', user: this.computedUser};
      if (this.role === 'test-retoucher') params.role = 'retoucher';
      this.idleLoading = true;

      clearInterval(this.timer);
      this.secondsCounter = 0;
      let data;
      let formData = new FormData();
      formData.append('role', this.role);

      if(Object.keys(this.computedUser).length > 0){
        for(const prop in this.computedUser){
          if(typeof this.computedUser[prop] != 'object'){
            formData.append(prop, this.computedUser[prop]);
          }
        }
      }

      await this.$store.dispatch("order/setToIdleTime", formData)

      data = this.$store.getters["order/setToIdleTime"];
      //this.$emit('retry', true);

      if ('success' in data) {
        this.timer = setInterval(() => {
          this.secondsCounter++;
          if(this.secondsCounter >= 10 && this.idleLoading === true) this.idleLoading = false;
        }, 1000);
      } else if ('error' in data) {
        this.idleLoading = false;
        alert(data.error);
      } else {
        this.idleLoading = false;
        alert('Something went wrong wit setting idle time');
      }

    },
    async getNewOrder() {
      //this.$emit('is-loading', true);

      let params = { role:'retoucher', education: null, funcBased: true};
      if (this.role === 'test-retoucher') params.role = 'retoucher';
      this.loading = true;
      let data;

      await this.$store.dispatch("order/getNewOrder", params)

      data = this.$store.getters["order/getNewOrder"];
      // if (data.status === "ok") {
      //   this.$emit('retry', true);
      // } else {
      //   this.$emit('retry', true);
      // }
      this.$emit('retry', true);
      //this.$emit('is-loading', false);
      this.loading = false;
    },
    async wantSignUp() {

      // let updateParams = {date, time, msg, retoucher, week, view, keyLockIstoSet, dataToUpdate}
      // let params = { urlToUpdate, updateParams};
      let message = "Do you want?";

      if (confirm(message)) {
        await this.$store.dispatch("schedule/scheduleRetoucherSignUpNow");
      }

    },
    // copyTgCode(code) {
    //   if (code) {
    //     const input = document.createElement('input');
    //     input.value = code;
    //     document.body.appendChild(input);
    //     input.select();
    //     const successful = document.execCommand('copy');
    //     document.body.removeChild(input);
    //     if (successful) {
    //       UIkit.notification({
    //         message: this.local_page_keys.copy_telegram_code,
    //         pos: 'top-center',
    //         status: 'primary',
    //         timeout: 1500
    //       })
    //     }
    //   }
    // },
    // startCountdown() {
    //   this.intervalId = setInterval(() => {
    //     if (this.countdown > 0) {
    //       this.countdown--;
    //     } else {
    //       clearInterval(this.intervalId);
    //     }
    //   }, 1000); // Обновляем каждую секунду
    // },
    startCountdownTtl() {
      this.intervalTtlId = setInterval(() => {
        if (this.secondsCounterTemporaryCashOrdersTtlTime > 0) {
          this.secondsCounterTemporaryCashOrdersTtlTime--;
        } else {
          clearInterval(this.intervalTtlId);
        }
      }, 1000); // Обновляем каждую секунду
    },
  },
  watch: {
    'downtime.now': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if(this.$refs.childRefNewOrders && typeof this.$refs.childRefNewOrders.fetchCountNewOrders === 'function'){
          this.$refs.childRefNewOrders.fetchCountNewOrders();
        }
      }
    },
    'downtime.user_idle_time_seconds': function (newVal, oldVal) {
      if (newVal !== oldVal && Math.abs(this.secondsCounter - newVal) > 10) {
        this.secondsCounter = newVal;
      }
    },
    'downtime.temporary_cash_orders_ttl_time': function (newVal, oldVal) {
      if(newVal
          && newVal > 0
          && newVal !== oldVal
          && Math.abs(this.secondsCounterTemporaryCashOrdersTtlTime - newVal) > 10){
          this.secondsCounterTemporaryCashOrdersTtlTime = newVal;
          this.startCountdownTtl();
      }

    },
    // 'downtime.telegram_code.unix_time': function (newUnixTime, oldUnixTime) {
    //   if (newUnixTime !== oldUnixTime) {
    //     // Обновляем счетчик обратного отсчета
    //     this.countdown = 100;
    //     // Перезапускаем счетчик
    //     clearInterval(this.intervalId);
    //     this.startCountdown();
    //   }
    // },
  },
  computed: {
    computedDowntime(){
      return this.downtime;
    },
    computedTemporaryCashOrdersTtltime(){
      return this.downtime.temporary_cash_orders_ttl_time;
    },
    formattedTime() {
      const hours = Math.floor(this.secondsCounter / 3600);
      const minutes = Math.floor((this.secondsCounter % 3600) / 60);
      const seconds = this.secondsCounter % 60;

      return [hours, minutes, seconds]
          .map(val => val.toString().padStart(2, '0'))
          .join(' : ');
    },
    // formattedTimeTgCode() {
    //   const minutes = Math.floor(this.countdown / 60);
    //   const seconds = this.countdown % 60;
    //   // Форматируем минуты и секунды как двузначные числа
    //   const formattedMinutes = String(minutes).padStart(2, '0');
    //   const formattedSeconds = String(seconds).padStart(2, '0');
    //
    //   return `${formattedMinutes}:${formattedSeconds}`;
    // },
    computedUser(){
      return this.user;
    },
    calculateUserIdleTime()
    {
      return this.downtime.user_idle_time;
    }
  },
  async mounted() {
    this.local_page_keys = await this.$filtergetLocalisationPages(['order-downtime','order-idle-time']);

    this.role = await this.$store.getters['profile/role'];
    this.showTimer = this.downtime.inactivity_timer_start !== null;
    if (this.downtime.inactivity_timer_start !== null) {
      this.orderCurrDate = Object.keys(this.downtime).includes('now') ? Date.parse(this.downtime.now) : Date.now();
      this.orderDateTime = Date.parse(this.downtime.inactivity_timer_start);
      this.interval = setInterval(() => {
        this.orderCurrDate += 1000;
        this.seconds = this.diffOrderMinutes('seconds');
        this.minutes = this.diffOrderMinutes('minutes');
        this.hours = this.diffOrderMinutes('hours');
        this.orderdays = this.diffOrderMinutes('days');
      }, 1000);
    }
    this.interval2 = setInterval(() => {
      if(typeof this.computedDowntime == 'object' , Object.keys(this.computedDowntime).length > 0){
        this.retryCounter = 0;
        this.$emit('retry', true);
      } else {
        this.retryCounter += 2;
      }
      if(this.retryCounter >= 20){
        this.retryCounter = 0;
        this.$emit('retry', true);
      }
    }, 2000);

    //this.startCountdown()
    if('user_idle_time_seconds' in this.downtime && Number(this.downtime.user_idle_time_seconds) > 0){
      if(this.secondsCounter == 0 && this.downtime.user_idle_time_seconds > 0){
        this.secondsCounter = this.downtime.user_idle_time_seconds;
      }
      this.timer = setInterval(() => {
        this.secondsCounter++;
      }, 1000);
    } else {
      clearInterval(this.timer);
      this.secondsCounter = 0;
    }

  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.interval2);
    clearInterval(this.timer);
    clearInterval(this.intervalTtlId);
  }

}
</script>

<style>
</style>